import { Resource as e } from "@coveo/platform-client";
//#region src/resources/BackendOnlyResource.ts
var t = class extends e {
	constructor(e, t, n) {
		super(e, t), this.internalAPI = n;
	}
};
//#endregion
export { t as BackendOnlyResource };

//# sourceMappingURL=BackendOnlyResource.js.map